<div class="header-row" [ngClass]="{'expanded': expanded, 'expandLocked': locked}">
    <div class="toggler" (click)="toggle()">
        <i class="caret far fa-chevron-down" [ngClass]="{'open': expanded}"></i>
    </div>
    <div class="header-row-content">
        <ng-content select="[item-header]"></ng-content>
    </div>
</div>
@if(expanded) {
<div>
    <ng-container *ngTemplateOutlet="templateRef()"></ng-container>
</div>
}